export const MSG_TYPE_FLOW_START = 'FLOW_START';
export const MSG_TYPE_HIDE_MODAL = 'HIDE_MODAL';
export const MSG_TYPE_MODAL_HIDDEN = 'MODAL_HIDDEN';
export const MSG_TYPE_WIZARD_COMPLETE = 'WIZARD_COMPLETE';
export const MSG_TYPE_RESIZE_COMPLETE = 'RESIZE_COMPLETE';
export const MSG_TYPE_LINK_CLICK = 'LINK_CLICK';
export const MSG_TYPE_ADD_ALERT = 'ADD_ALERT';